import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { isIndicadorRole } from '@/config/routeAccess'
import { ParceirosBrandShell } from './ParceirosBrandShell'
import { ParceirosPublicHome } from './ParceirosPublicHome'
import { PARCEIROS_HOME_PATH } from './parceirosNav'

export default function ParceirosLanding() {
  const user = useAuthStore((s) => s.user)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isPartner = isAuthenticated && user && isIndicadorRole(user.role)

  if (isPartner) {
    return <Navigate to={PARCEIROS_HOME_PATH} replace />
  }

  return (
    <ParceirosBrandShell>
      <ParceirosPublicHome />
    </ParceirosBrandShell>
  )
}
